import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M23.071 39.606c2.212-1.75 5.129-4.431 8.742-8.041 3.889-3.886 6.48-6.939 7.759-9.126.404-.692.618-1.48.618-2.281v-8.617c0-1.333-.098-1.839-.377-2.36a2.4 2.4 0 0 0-.997-.996c-.521-.279-1.027-.376-2.362-.376h-8.65c-.821 0-1.626.222-2.329.644-2.068 1.24-5.066 3.812-8.96 7.703q-5.533 5.53-8.118 8.792a2.71 2.71 0 0 0-.075 3.27c1.242 1.723 3.028 3.751 5.356 6.076q3.504 3.502 6.12 5.385c.985.71 2.321.68 3.273-.073m1.124 1.418a4.53 4.53 0 0 1-5.455.122q-2.747-1.979-6.342-5.573-3.586-3.58-5.545-6.299a4.52 4.52 0 0 1 .125-5.449q2.66-3.355 8.257-8.948c3.991-3.988 7.083-6.64 9.309-7.975A6.34 6.34 0 0 1 27.804 6h8.65c1.608 0 2.396.152 3.216.59a4.2 4.2 0 0 1 1.74 1.738c.438.82.59 1.607.59 3.213v8.617a6.3 6.3 0 0 1-.865 3.194c-1.376 2.351-4.052 5.505-8.042 9.492-3.659 3.655-6.622 6.38-8.899 8.18m10.564-24.172a3.62 3.62 0 0 1-3.62-3.617 3.62 3.62 0 0 1 3.62-3.618c2 0 3.62 1.62 3.62 3.617a3.62 3.62 0 0 1-3.62 3.618m0-1.809a1.81 1.81 0 1 0 .002-3.619 1.81 1.81 0 0 0-.002 3.62",
      clipRule: "evenodd"
    }
  )
);
var SvgTagsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TagsOutlined_default = SvgTagsOutlined;

export { TagsOutlined_default as default };
